import type { Currency } from '@ps/web-core-enums';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import { convertAmountByRate } from '../../utils/cashier';

interface Props {
  inverted?: boolean;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
  sourceAmountInCents: number;
  sourceCurrency: Currency;
  targetCurrency: Currency;
  rate: number;
}

const ExchangeRateFormula: React.FC<Props> = ({
  inverted = true,
  maximumFractionDigits,
  minimumFractionDigits,
  sourceAmountInCents,
  sourceCurrency,
  targetCurrency,
  rate
}) => (
  <>
    <CurrencyAmount
      currency={sourceCurrency}
      value={sourceAmountInCents}
      currencyDisplay="code"
      style="currency"
    />
    {' = '}
    <CurrencyAmount
      currency={targetCurrency}
      value={convertAmountByRate(
        sourceAmountInCents,
        rate,
        targetCurrency,
        inverted,
        maximumFractionDigits ? maximumFractionDigits - 2 : 0
      )}
      currencyDisplay="code"
      style="currency"
      maximumFractionDigits={maximumFractionDigits}
      minimumFractionDigits={minimumFractionDigits}
    />
  </>
);

export default ExchangeRateFormula;
